import React from "react";
import PropTypes from "prop-types";
import DocVerdictBar from "../Inbox/DocVerdictBar";
import useWaitingOnWorkItems from "../../hooks/useWaitingOnWorkItems";

/**
 * The open work items this document belongs to, pinned under the matter
 * document toolbar — so whoever the item is with can comment, return,
 * snooze, or accept it without leaving the document. Lives in the
 * document view rather than the AI panel because the homepage's
 * "Open document" link lands with that panel closed. Renders nothing
 * when the document belongs to no open work item.
 */
const DocumentWorkItemBar = ({ documentId }) => {
  const { waitingOn, reload } = useWaitingOnWorkItems(documentId || null);

  return (
    <DocVerdictBar
      items={waitingOn?.linked || []}
      onActed={reload}
      title="Work item on this document"
      showMatter={false}
    />
  );
};

DocumentWorkItemBar.propTypes = {
  documentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DocumentWorkItemBar;
